export default __webpack_public_path__ + "static/media/pm_logo.35aae707.png";